export const APP_VERSION = '2.2.0';
export const APP_PROJECT_NAME = 'BOGE';
